
import mapboxgl, { LngLat, Marker } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { WindowType } from '../../util';
import { BasePoI, TypePOI } from '../backend/backendapi';
import { MapPoint } from './models';
import MapboxWrapper from '../map/MapboxWrapper';
import RtMarker from '../map/marker/RtMarker';
import RtPopup from './RtPopup';
import RtPath from './RtPath';

Vue.use(Toasted, { duration: 2000 });

declare var window: WindowType;

@Component({
  name: 'MapWithMarkers',
  components: {
    MapboxWrapper,
    RtMarker,
    RtPath,
    RtPopup,
  },
})
export default class MapWithMarkers extends Vue {
  @Prop({ required: true })
  readonly mapId!: string;
  @Prop({ default: 'mapbox://styles/mapbox/streets-v11' })
  readonly mapStyle!: string;
  @Prop({ required: true })
  readonly accessToken!: string;
  @Prop({ required: true })
  readonly pois!: BasePoI[];
  @Prop({ required: true })
  readonly visiblePathPois!: BasePoI[];
  @Prop({ default: null })
  readonly mapOptions!: mapboxgl.MapboxOptions;

  @Prop({ required: true })
  readonly dateFrom!: Date;
  @Prop({ required: true })
  readonly dateTo!: Date;
  @Prop({ required: true })
  readonly dateCurrent!: Date;

  flow = '';
  readonly offset = 25;
  addMenu = { show: false, center: new LngLat(0, 0) };
  private mapPopup: any = undefined;
  private map?: mapboxgl.Map;

  get bounds(): mapboxgl.LngLatBounds {
    return this.pois
        .filter(poi => poi.latitude !== undefined && poi.longitude !== undefined)
        .map(poi => new LngLat(poi.longitude!, poi.latitude!))
        .reduce((bounds, coord) => bounds.extend(coord), new mapboxgl.LngLatBounds());
  }

  get canEdit(): boolean {
    console.log('canEdit', window.application.permissions.map.edit);
    return window.application.permissions.map.edit;
  }

  get canDelete(): boolean {
    console.log('canDelete', window.application.permissions.map.delete);
    return window.application.permissions.map.delete;
  }

  get markers(): MapPoint[] {
    console.log('markers', this.pois);
    return this.pois.map(poi => {
      if (poi.latitude === undefined || poi.longitude === undefined) {
        return undefined;
      }
      const center = new LngLat(poi.longitude, poi.latitude);
      const p = new MapPoint();
      p.id = poi.id;
      p.type = poi.type;
      p.accountId = poi.fkAccountId;
      p.center = center;
      p.custom = true;
      p.draggable = false;
      p.color = 'blue';
      p.popup = true;
      p.popuptext = poi.name;
      p.poi = poi;
      p.history = poi.locationHistory?.map(e => ({ lng: e.longitude!, lat: e.latitude!, date: e.dateTime! }));
      return p;
    }).filter(e => e !== undefined) as MapPoint[];
  }

  get selectedAccountId(): number {
    return window.application.user.fkSelectedAccountId!;
  }

  zoomInto(lngLat: mapboxgl.LngLat, zoom: number): void {
    if (this.map !== undefined) {
      this.map.setCenter(lngLat);
      this.map.setZoom(zoom);
    }
  }

  private deleteSelected() {
    // if (this.selectedIndex.id !== undefined && this.selectedIndex.id !== "")
    //     this.service.deletePoI(this.selectedIndex.id);
    // this.fetchAndClear();
  }

  onMapLoaded(event: any) {
    console.log(`${this.mapId} map loaded`);
    this.map = event.map;

    if (!this.map) {
      return;
    }

    // Add zoom and rotation controls to the map.
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on('contextmenu', (event: mapboxgl.MapMouseEvent & mapboxgl.EventData) => {
      this.addPopup(event.lngLat);
      const selectedPoI = new BasePoI();
      selectedPoI.latitude = event.lngLat.lat;
      selectedPoI.longitude = event.lngLat.lng;
      this.$emit('poiClicked', selectedPoI);
    });

    if (this.markers.length > 0)
      this.map.fitBounds(this.bounds, { padding: 20 });
  }

  onMarkerClicked(event: { marker: Marker, poiId: string }) {
    const clickedPoints = this.pois.filter(poi => poi.id === event.poiId);
    if (clickedPoints.length > 0) {
      this.$emit('poiClicked', clickedPoints[0]);
    }
  }

  addMarker() {
    console.log('Add marker');
    this.flow = 'Add';
    const selectedPoI = new BasePoI();
    const lngLat = this.mapPopup.getLngLat();
    selectedPoI.latitude = lngLat.lat;
    selectedPoI.longitude = lngLat.lng;
    const p = new MapPoint();
    p.id = '';
    p.type = TypePOI.Waterpoint;
    p.center = lngLat;
    p.custom = true;
    p.draggable = false;
    this.markers.push(p);
    this.mapPopup.remove();
  }

  editItem(mapPoint: MapPoint) {
    this.$emit('poiEdit', mapPoint.poi!);
  }

  deleteItem(mapPoint: MapPoint) {
    this.$emit('poiDelete', mapPoint.poi!);
  }

  private addPopup(lngLat: LngLat) {
    if (this.map) {
      console.log(lngLat);
      const addSpan = document.createElement('span');
      addSpan.innerText = this.$i18n.t('btnEdit').toString();
      addSpan.onclick = this.addMarker;
      const el = document.createElement('div');
      el.className = 'context-menu';
      el.appendChild(addSpan);
      this.mapPopup = new mapboxgl.Popup({ closeOnClick: false })
          .setLngLat(lngLat)
          .setDOMContent(el)
          .addTo(this.map);
    }
  }
}
